<template>
    <div class="campaign-builder-modal">
        <DsModal
            is-open
            show-close
            size="lg"
            class="integration-modal"
            data-qa="integration-modal"
            :title="cell.value.name"
            @close="closeModal"
        >
            <template #header>
                <div v-if="iframeUrl">
                    {{ $t('funnel.edit.goal.integration.summary') }}
                </div>
            </template>
            <template #default>
                <iframe class="external-config-frame" :src="iframeUrl" />
            </template>
        </DsModal>
    </div>
</template>

<script>
import { v4 as uuid } from 'uuid';

const MESSAGE_TYPES = {
    SAVE: 'save',
    CLOSE: 'close',
    STATUS: 'status',
};

export default {
    props: {
        enabledIntegrations: {
            type: Array,
            default: () => [],
        },
        cell: {
            type: Object,
            default: () => ({
                value: {
                },
            }),
        },
        flagsInfo: {
            type: Object,
            default: () => ({}),
        },
        appInfo: {
            type: Object,
            required: true,
        },
    },

    emits: ['close-modal', 'update-cell-value'],

    data() {
        return {
            externalId: this.cell.value.externalId || uuid(),
        };
    },

    computed: {
        integrationByType() {
            return this.enabledIntegrations.find((integration) => integration.id === this.cell.value.integrationTriggerId);
        },

        iframeUrl() {
            const regex = /^(http|https)/;

            const matches = regex.exec(this.integrationByType?.configurationUrl);

            if (!matches) return null;

            const url = new URL(this.integrationByType?.configurationUrl);

            url.searchParams.append('externalEventId', this.externalId);
            url.searchParams.append('tenantId', this.appName);

            return url.toString();
        },

        appName() {
            return this.appInfo?.appName;
        },
    },

    mounted () {
        window.addEventListener('message', this.receiveMessage);
    },

    beforeUnmount () {
        window.removeEventListener('message', this.receiveMessage);
    },

    methods: {
        receiveMessage (event) {
            const { type } = event.data;

            if (type === MESSAGE_TYPES.CLOSE) {
                this.closeModal();
            } else if (type === MESSAGE_TYPES.SAVE) {
                const { externalEventId } = event.data;

                if (externalEventId) {
                    this.cell.value.externalId = externalEventId;
                }

                this.updateConfig();
            } else if (type === MESSAGE_TYPES.STATUS) {
                const { isReady } = event.data;

                this.updateReady(isReady);
            }
        },

        closeModal() {
            this.$emit('close-modal');
        },

        async updateConfig() {
            const updatedCell = { ...this.cell };

            updatedCell.value.externalId = this.externalId;

            this.$emit('update-cell-value', { cell: updatedCell });
        },

        async updateReady(ready) {
            const updatedCell = { ...this.cell };

            updatedCell.value.externalId = this.externalId;

            this.$emit('update-cell-value', { cell: updatedCell, preventClose: true, isReady: ready });
        },
    },
};
</script>

<style lang="scss" scoped>
.integration-modal {
    padding: 0;
}

.external-config-frame {
    width: 100%;
    height: 75vh;
    border: 0;
}
</style>
